import { ApplicationFieldRow, applicationRowsFromInvite } from './applicationDisplay';
import { ApplicationDraft } from './applicationFromRecord';
import { GeneralInviteTag } from './inviteTags';

export type FillableApplication = {
    fileName?: string;
    uploadedAt?: string;
    summary?: string;
    fields?: ApplicationFieldRow[];
};

export type FillableInvite = {
    ownerName: string;
    phone: string;
    tags: GeneralInviteTag[];
    application?: FillableApplication;
};

const hasApplicationData = (application?: FillableApplication): boolean =>
    Boolean(
        application &&
            (application.summary || (application.fields && application.fields.length))
    );

export const fillMissingFromDraft = (
    current: FillableInvite,
    draft: ApplicationDraft
): { next: FillableInvite; changed: boolean } => {
    const ownerName = current.ownerName.trim() || draft.ownerName;
    const phone = current.phone.trim() || draft.phone;
    const tags: GeneralInviteTag[] = current.tags.length ? current.tags : ['puppy-application'];
    const currentRows = applicationRowsFromInvite(current.application);
    const draftRows = (draft.fields || []).filter((row) => row.label && row.value);
    const seen = new Set(currentRows.map((row) => row.label));
    const merged = currentRows.slice();
    draftRows.forEach((row) => {
        if (!seen.has(row.label)) {
            seen.add(row.label);
            merged.push(row);
        }
    });

    let application = current.application;
    if (!hasApplicationData(current.application) && (draft.summary || draftRows.length)) {
        application = {
            fileName: draft.sourceLabel,
            uploadedAt: new Date().toISOString(),
            summary: draft.summary,
            fields: draft.fields,
        };
    } else if (merged.length > currentRows.length) {
        application = {
            fileName: current.application?.fileName || draft.sourceLabel,
            uploadedAt: current.application?.uploadedAt || new Date().toISOString(),
            summary: current.application?.summary || draft.summary,
            fields: merged,
        };
    }

    const changed =
        ownerName !== current.ownerName ||
        phone !== current.phone ||
        tags.join(',') !== current.tags.join(',') ||
        application !== current.application;

    return {
        next: {
            ownerName,
            phone,
            tags,
            application,
        },
        changed,
    };
};
